import { render, staticRenderFns } from "./InscripcionFiles.vue?vue&type=template&id=2813fe32&"
import script from "./InscripcionFiles.vue?vue&type=script&lang=js&"
export * from "./InscripcionFiles.vue?vue&type=script&lang=js&"
import style0 from "./InscripcionFiles.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports